// extracted by mini-css-extract-plugin
module.exports = {"results__items":"results-section_results__items__mnDzP","results__item":"results-section_results__item__Wgnyx","results__item__title":"results-section_results__item__title__cvX3g"};